import { render, staticRenderFns } from "./discussion.vue?vue&type=template&id=5985808c&scoped=true"
import script from "./discussion.vue?vue&type=script&lang=js"
export * from "./discussion.vue?vue&type=script&lang=js"
import style0 from "./discussion.vue?vue&type=style&index=0&id=5985808c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985808c",
  null
  
)

export default component.exports